import { useState } from "react";
import WithoutSidebar from "../../layouts/WithOutSidebar";
import "./homePage.css";
import { useNavigate } from "react-router-dom";
const HomePage = () => {
  const navigate = useNavigate();
  const [codePayment, setCodePayment] = useState("");
  const confirmation = () => {
    navigate(`${codePayment}`);
  };
  const checkEnter = (event) => {
    if (event.keyCode === 13) {
      confirmation();
    }
  };
  return (
    <WithoutSidebar footer={true} isLogin={true}>
      <div className="homePage-container">
        <div className="homePage-container__background"></div>

        <div className="container">
          <div className="homePage-box">
            <div className="homePage-box__header">
              فرم دریافت اطلاعات پرداخت
            </div>
            <div className="payment">
              <label>شناسه پرداخت هما</label>
              <div className="payment-input">
                <input
                  type="text"
                  placeholder="123456"
                  onChange={(e) => {
                    console.log(e.target.value);
                    setCodePayment(e.target.value);
                  }}
                  onKeyDown={(e) => checkEnter(e)}
                />
                {/* <Input inputField={inputFields.payment} onChange={handleChange} /> */}
              </div>
            </div>
            {/* <div className="telephone">
              <label>شماره تماس </label>
              <div className="telephone-input">
                <input
                  type="text"
                  placeholder="09000000000"
                  onChange={(e) => {
                    console.log(e.target.value);
                  }}
                /> */}
            {/* <Input inputField={inputFields.telephone} onChange={handleChange} /> */}
            {/* </div>
            </div> */}

            <div className="wrapper-btn">
              <button className="homePage-box__btn" onClick={confirmation}>
                تایید
              </button>
            </div>
          </div>
        </div>
      </div>
    </WithoutSidebar>
  );
};
export default HomePage;
